import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  loading: boolean
  entity: Response.WorkingDate[]
}

const initialState: State = {
  loading: false,
  entity: [],
}

const { actions, reducer } = createSlice({
  name: 'working_dates',
  initialState,
  reducers: {
    updateEntity: (state, action: PayloadAction<Response.WorkingDate[]>) => {
      state.entity = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
